import { MenuDivider, MenuItem } from "@blueprintjs/core";

import { MoreMenu } from "@/components/pieces/more/MoreMenu";

interface EvaluationCriteriaItemMenuProps {
  itemId: string;
  isLinked: boolean;
  onEdit: (itemId: string) => void;
  onUnlink: (itemId: string) => void;
  onDelete: (itemId: string) => void;
  insideAccordion?: boolean;
}

export function EvaluationCriteriaItemMenu({
  itemId,
  isLinked,
  onEdit,
  onUnlink,
  onDelete,
  insideAccordion = false,
}: EvaluationCriteriaItemMenuProps) {
  return (
    <MoreMenu useSpanTrigger={insideAccordion}>
      <MenuItem text="Edit" onClick={() => onEdit(itemId)} />
      {isLinked ? (
        <MenuItem text="Unlink from Rubric" onClick={() => onUnlink(itemId)} />
      ) : null}
      <MenuDivider />
      <MenuItem
        text="Delete"
        intent="danger"
        onClick={() => onDelete(itemId)}
      />
    </MoreMenu>
  );
}
